import { Box, GridItem, Heading, SimpleGrid } from "@chakra-ui/react";
import { AdvantageCard } from "@/components/advantageCard";
import PageLayout from "@/layouts/pageLayout";
import { USE_CASES_CONSTANTS } from "./constants";

const UseCasesComponent = () => {
  return (
    <Box bgColor={"#EDF2F7"} pb={12}>
      <PageLayout>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} gap={12}>
          <GridItem colSpan={{ base: 1, sm: 2, md: 1 }} alignSelf={"center"}>
            <Heading as="h2" fontWeight={"400"} fontSize={"40px"} lineHeight={1.2}>
              Built For Modern Workloads
            </Heading>
          </GridItem>
          <GridItem colSpan={{ base: 1, sm: 2, md: 3 }} alignSelf={"center"}>
            <SimpleGrid columns={{ base: 1, sm: 2 }} gap={8}>
              {USE_CASES_CONSTANTS.map((item, index) => (
                <AdvantageCard
                  key={index}
                  text={item.text}
                  image={item.image}
                  title={item.title}
                  bgColor={"white"}
                  getHoverEffect
                />
              ))}
            </SimpleGrid>
          </GridItem>
        </SimpleGrid>
      </PageLayout>
    </Box>
  );
};

export default UseCasesComponent;
